<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <form @submit.prevent="saveWA()">
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <label for="whatsapp">Whatsapp</label>
                  <select
                    class="custom-select"
                    name="whatsapp"
                    id="whatsapp"
                    v-model="wa.whatsapp"
                    :class="{
                      'is-invalid': submitted && $v.wa.whatsapp.$error,
                    }">
                      <option value=""></option>
                      <option value="1">Ativo</option>
                      <option value="0">Desativado</option>
                  </select>
                  <div
                    v-if="submitted && !$v.wa.whatsapp.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
              <span v-if="parseInt(wa.whatsapp) === 1">
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="wa_messenger">WhatsApp Messenger (Gerenciador de Conversas)</label>
                      <select
                        id="wa_messenger"
                        name="wa_messenger"
                        v-model="wa.wa_messenger"
                        class="form-control"
                      >
                        <option :value="true">Ativado</option>
                        <option :value="false">Desativado</option>
                      </select>
                      <small class="text-muted">Ativa o gerenciador de conversas e notificacoes em tempo real.</small>
                    </div>
                  </div>
                </div>
              </span>

              <!-- Assistente IA -->
              <span v-if="parseInt(wa.whatsapp) === 1">
                <hr class="my-4" />
                <h5 class="mb-3"><i class="bx bx-bot mr-1"></i> Assistente IA (Auto-Responder)</h5>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Assistente IA</label>
                      <select class="custom-select" v-model="wa.ai_auto_responder">
                        <option :value="true">Ativado</option>
                        <option :value="false">Desativado</option>
                      </select>
                      <small class="text-muted">Responde automaticamente perguntas dos participantes via WhatsApp</small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Nome do Assistente</label>
                      <input v-model="wa.ai_assistant_name" type="text" class="form-control" placeholder="Ex: Luna, Concierge Virtual" />
                      <small class="text-muted">Personaliza a identidade do assistente</small>
                    </div>
                  </div>
                </div>

                <div v-if="wa.ai_auto_responder" class="row mt-2">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Mensagem de Boas-vindas</label>
                      <textarea v-model="wa.ai_welcome_message" class="form-control" rows="2" placeholder="Ex: Ola! Sou a Luna, assistente virtual do evento. Como posso ajudar?"></textarea>
                      <small class="text-muted">Primeira mensagem quando alguem envia uma saudacao</small>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Contexto Extra</label>
                      <textarea v-model="wa.ai_context_extra" class="form-control" rows="5" placeholder="Informacoes adicionais que a IA deve saber sobre o evento. Ex: Wi-Fi: rede EventoXYZ senha 1234, Coffee break as 10h e 15h30, Estacionamento com 200 vagas..."></textarea>
                      <small class="text-muted">Informacoes livres que complementam os dados do evento e as FAQs</small>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Instrucoes de Comportamento</label>
                      <textarea v-model="wa.ai_behavior_instructions" class="form-control" rows="6" placeholder="Instrucoes de como a IA deve se comportar nas respostas..."></textarea>
                      <small class="text-muted">Defina o tom, estilo e regras de como o assistente deve responder. Cada linha e uma instrucao.</small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Quando nao souber responder</label>
                      <select class="custom-select" v-model="wa.ai_no_answer_behavior">
                        <option value="handoff">Transferir para atendente humano</option>
                        <option value="say_dont_know">Dizer que nao tem a informacao</option>
                      </select>
                    </div>
                  </div>
                </div>
              </span>

              <div class="row mt-3 mb-2">
                <div class="col-sm-12">
                  <div class="float-right">
                    <button type="submit" class="btn btn-primary mr-1">
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
      <div class="card">
        <div class="card-body">
          <b-tabs nav-class="nav-tabs-custom" content-class="p-3 text-muted" lazy>
            <b-tab active>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="far fa-envelope"></i>
                </span>
                <span class="d-none d-sm-inline-block">Configurações de status</span>
              </template>
              <WAStatusTemplates />
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="bx bx-bot"></i>
                </span>
                <span class="d-none d-sm-inline-block">FAQs do Assistente IA</span>
              </template>
              <WAFaqs />
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="bx bx-check-circle"></i>
                </span>
                <span class="d-none d-sm-inline-block">RSVP via AutoResponder</span>
              </template>
              <WARsvpButton />
            </b-tab>
          </b-tabs>
        </div>
      </div>
  </Layout>
</template>
<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import WAStatusTemplates from './status/Index.vue'
import WAFaqs from './faq/Index.vue'
import WARsvpButton from './rsvp-button/Index.vue'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    Layout,
    PageHeader,
    WAStatusTemplates,
    WAFaqs,
    WARsvpButton
  },
  name: 'setting-rsvp',
  page: {
    title: 'Parâmetros do WhatsApp',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      submitted: false,
      configEvent: false,
      wa: {},
      title: 'Parâmetros do WhatsApp',
      items: [{
        text: 'Configurações gerais',
        href: '/'
      },
      {
        text: 'Parâmetros do WhatsApp',
        active: true
      }
      ]
    }
  },
  validations () {
    let wa = {
      whatsapp: { required }
    }

    return {
      wa: wa
    }
  },
  mounted () {
    let loader = this.$loading.show()
    this.getSettingWA().then(() => {
      console.log(this.data)
      this.wa = this.data
      loader.hide()
    })
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('wa', { data: 'settingWA' })
  },
  methods: {
    ...mapActions('wa', {
      getSettingWA: 'GetSettingWA',
      postSettingWA: 'saveWA'
    }),
    initSetting () {
      this.configEvent = true
    },
    async saveWA () {
      this.submitted = true
      this.$v.wa.$touch()
      if (this.$v.wa.$invalid) {
        window.scroll(0, 0)
        return
      }
      let loader = this.$loading.show()
      try {
        await this.postSettingWA(this.wa).then(() => {
          let message = 'Sucesso: Dados atualizados com sucesso.'
          let delay = 2500
          successMessage(message, delay)
          loader.hide()
        })
      } catch (err) {
        console.log(err)
        loader.hide()
        errorMessage('Alerta: ' + err.response.data.message)
      }
    }
  }
}
</script>
<style>
</style>
